import { Observable } from 'rxjs';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import * as HrModels from '../hr.models';
import { Constructor, HrApiClient } from '../shared/hr-api-client';

export function withHrCountryPacksApi<TBase extends Constructor<HrApiClient>>(Base: TBase) {
  return class extends Base {
    countryPacks(countryCode?: string, active?: boolean): Observable<APIResponseWrapper<HrModels.HrCountryPack[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrCountryPack[]>>(`${this.baseUrl}/country-packs`, {
          params: this.params({ countryCode, active })
        });
      }
    
    countryPackVersions(countryPackId?: number): Observable<APIResponseWrapper<HrModels.HrCountryPackVersion[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrCountryPackVersion[]>>(`${this.baseUrl}/country-packs/versions`, {
          params: this.params({ countryPackId })
        });
      }
    
    tenantCountryPackSettings(owningCompanyId?: number, countryCode?: string, active?: boolean): Observable<APIResponseWrapper<HrModels.HrTenantCountryPackSetting[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrTenantCountryPackSetting[]>>(`${this.baseUrl}/country-packs/settings`, {
          params: this.params({ owningCompanyId, countryCode, active })
        });
      }
    
    saveTenantCountryPackSetting(request: HrModels.HrCountryPackActivationRequest): Observable<APIResponseWrapper<HrModels.HrTenantCountryPackSetting>> {
        return this.http.post<APIResponseWrapper<HrModels.HrTenantCountryPackSetting>>(`${this.baseUrl}/country-packs/settings`, request);
      }
    
    countryPackDocumentRequirements(countryCode?: string, countryPackVersionId?: number): Observable<APIResponseWrapper<HrModels.HrCountryPackDocumentRequirement[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrCountryPackDocumentRequirement[]>>(`${this.baseUrl}/country-packs/document-requirements`, {
          params: this.params({ countryCode, countryPackVersionId })
        });
      }
    
    countryPackStatutoryRules(countryCode?: string, countryPackVersionId?: number, active?: boolean): Observable<APIResponseWrapper<HrModels.HrCountryPackStatutoryRule[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrCountryPackStatutoryRule[]>>(`${this.baseUrl}/country-packs/statutory-rules`, {
          params: this.params({ countryCode, countryPackVersionId, active })
        });
      }
    
    countryPackExportFormats(countryCode?: string, countryPackVersionId?: number): Observable<APIResponseWrapper<HrModels.HrCountryPackExportFormat[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrCountryPackExportFormat[]>>(`${this.baseUrl}/country-packs/export-formats`, {
          params: this.params({ countryCode, countryPackVersionId })
        });
      }
    
    employeeComplianceProfiles(owningCompanyId?: number, employeeId?: number, countryCode?: string): Observable<APIResponseWrapper<HrModels.HrEmployeeComplianceProfile[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrEmployeeComplianceProfile[]>>(`${this.baseUrl}/country-packs/employee-profiles`, {
          params: this.params({ owningCompanyId, employeeId, countryCode })
        });
      }
    
    saveEmployeeComplianceProfile(request: HrModels.HrEmployeeComplianceProfile): Observable<APIResponseWrapper<HrModels.HrEmployeeComplianceProfile>> {
        return this.http.post<APIResponseWrapper<HrModels.HrEmployeeComplianceProfile>>(`${this.baseUrl}/country-packs/employee-profiles`, request);
      }
    
    payrollStatutoryOutputs(owningCompanyId?: number, payrollRunId?: number, countryCode?: string): Observable<APIResponseWrapper<HrModels.HrPayrollStatutoryOutput[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrPayrollStatutoryOutput[]>>(`${this.baseUrl}/country-packs/payroll/statutory-outputs`, {
          params: this.params({ owningCompanyId, payrollRunId, countryCode })
        });
      }
    
    previewPayrollStatutoryOutputs(payrollRunId: number, owningCompanyId?: number, countryCode?: string): Observable<APIResponseWrapper<HrModels.HrPayrollStatutoryOutput[]>> {
        return this.http.post<APIResponseWrapper<HrModels.HrPayrollStatutoryOutput[]>>(`${this.baseUrl}/country-packs/payroll/runs/${payrollRunId}/statutory-preview`, { owningCompanyId, countryCode });
      }
    
    generateStatutoryExport(request: HrModels.HrStatutoryExportRequest): Observable<APIResponseWrapper<HrModels.HrStatutoryExportBatch>> {
        return this.http.post<APIResponseWrapper<HrModels.HrStatutoryExportBatch>>(`${this.baseUrl}/country-packs/exports`, request);
      }
    
    statutoryExportBatches(owningCompanyId?: number, countryCode?: string, payrollRunId?: number, limit?: number): Observable<APIResponseWrapper<HrModels.HrStatutoryExportBatch[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrStatutoryExportBatch[]>>(`${this.baseUrl}/country-packs/exports`, {
          params: this.params({ owningCompanyId, countryCode, payrollRunId, limit })
        });
      }
    
    previewEndOfService(request: HrModels.HrEndOfServicePreviewRequest): Observable<APIResponseWrapper<HrModels.HrEndOfServicePreview>> {
        return this.http.post<APIResponseWrapper<HrModels.HrEndOfServicePreview>>(`${this.baseUrl}/country-packs/eosb-preview`, request);
      }
    
    endOfServicePreviews(owningCompanyId?: number, employeeId?: number, countryCode?: string, limit?: number): Observable<APIResponseWrapper<HrModels.HrEndOfServicePreview[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrEndOfServicePreview[]>>(`${this.baseUrl}/country-packs/eosb-preview`, {
          params: this.params({ owningCompanyId, employeeId, countryCode, limit })
        });
      }
  };
}

